export class Notification {
  notificationId!: string
  date!: string
  resourceKey!: string
  text!: string
  madeBy!: string
  madeByName!: string
  param1!: string
  param1Ar!: string
  param1En!: string
  param2!: any
  param2Ar!: any
  param2En!: any
  param3Ar!: any
  param3En!: any
  param3!: any
  param4Ar!: any
  param4En!: any
  param4!: any
  param5Ar!: any
  param5En!: any
  param5!: any
  isSeen!: boolean
  objectId!: string
  notificationType!: string
}
export class NotificationsModel {
  unSeenNotificationsCount!: number;
  pageData!: Notification[];
  pageNumber!: number;
  pageSize!: number;
  totalCount!: number;
}
export enum NotificationType {
  User = 'User',
}
